interface Props {
  count?: number
}

export function EntityListSkeleton({ count = 8 }: Props) {
  return (
    <>
      {Array.from({ length: count }, (_, i) => (
        <div
          key={i}
          className="flex flex-col gap-1.5 border-b border-grey4 px-4 py-3"
        >
          <div className="h-4 w-2/3 animate-pulse rounded bg-grey4" />
          <div className="h-3 w-1/3 animate-pulse rounded bg-grey4" />
        </div>
      ))}
    </>
  )
}
